import styled from "styled-components";
import { Upload, Modal } from "antd";

const { Dragger } = Upload;

const LinkText = styled.div`
  font-family: Gilroy, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #307fe2;
`;

const H4 = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #595959;
  margin-bottom: 16px;
  font-family: Gilroy, sans-serif;
`;

const ModalCustom = styled(Modal)`
  font-family: Gilroy, sans-serif;

  & .slick-arrow {
    ::before {
      font-size: 22px;
      color: #000;
    }
  }

  .ant-modal-body {
    padding: 24px 28px;
  }
`;

const ContainerImg = styled.div`
  & .btn-delete {
    width: 464px;
    position: absolute;
    bottom: 0px;
    color: #cf1322;
    background-color: white;
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
  }
  & img {
    width: 100%;
    height: auto;
  }
`;

const CustomDragger = styled(Dragger)``;

export { LinkText, H4, CustomDragger, ModalCustom, ContainerImg };
